document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const btn = event.target.closest('[data-accordion-button]');
  if (!btn) return;
  const item = btn.closest('.faq-item');
  item.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
});

function formatProductMoney(cents, currencyCode) {
  const amount = Number(cents || 0) / 100;
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currencyCode || 'USD'
    }).format(amount);
  } catch (error) {
    return '$' + amount.toFixed(2);
  }
}

function resolveVariantMediaIndex(wrapper, option, slides) {
  if (!option || !slides.length) return -1;
  const variantName = option.textContent.replace('— Sold out', '').trim().toLowerCase();

  // The balaclava's Shopify variant media was imported with Black and Gray
  // reversed. Prefer the verified color gallery positions for this product.
  if (wrapper && wrapper.dataset.productKind === 'balaclava' && option.dataset.colorMediaIndex !== undefined) {
    const colorIndex = Number(option.dataset.colorMediaIndex);
    if (Number.isInteger(colorIndex) && colorIndex >= 0 && colorIndex < slides.length) return colorIndex;
  }

  if (option.dataset.mediaId) {
    const mediaIndex = slides.findIndex(function (slide) { return slide.dataset.mediaId === option.dataset.mediaId; });
    if (mediaIndex >= 0) return mediaIndex;
  }

  const altIndex = slides.findIndex(function (slide) {
    return (slide.dataset.mediaAlt || '').toLowerCase().includes(variantName);
  });
  if (altIndex >= 0) return altIndex;
  return Math.min(Number(option.dataset.variantIndex || 0), Math.max(slides.length - 1, 0));
}

document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
  const viewport = gallery.querySelector('[data-product-media-viewport]');
  const slides = Array.from(gallery.querySelectorAll('[data-product-media-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-product-media-thumb]'));
  const previous = gallery.querySelector('[data-product-media-prev]');
  const next = gallery.querySelector('[data-product-media-next]');
  if (!viewport || !slides.length) return;

  let activeIndex = 0;
  let frame;

  function updateActive(index) {
    activeIndex = Math.max(0, Math.min(index, slides.length - 1));
    thumbs.forEach(function (thumb, thumbIndex) {
      thumb.classList.toggle('is-active', thumbIndex === activeIndex);
    });
  }

  function showMedia(index, behavior) {
    const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
    viewport.scrollTo({ left: nextIndex * viewport.clientWidth, behavior: behavior || 'smooth' });
    updateActive(nextIndex);
  }

  gallery.showProductMedia = showMedia;
  if (previous) previous.addEventListener('click', function () { showMedia(activeIndex - 1); });
  if (next) next.addEventListener('click', function () { showMedia(activeIndex + 1); });
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () { showMedia(Number(thumb.dataset.productMediaThumb)); });
  });
  viewport.addEventListener('scroll', function () {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(function () {
      updateActive(Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1)));
    });
  }, { passive: true });
  const productRoot = gallery.closest('[data-product-root]');
  const selectedVariant = productRoot && productRoot.querySelector('[data-variant-select] option:checked');
  const selectedIndex = resolveVariantMediaIndex(productRoot, selectedVariant, slides);
  if (selectedIndex >= 0) showMedia(selectedIndex, 'auto');
});

document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const wrapper = select.closest('[data-product-root]');
  const option = select.options[select.selectedIndex];
  if (!wrapper) return;

  const currencyCode = wrapper.dataset.currencyCode || 'USD';
  const priceText = formatProductMoney(option.dataset.priceCents, currencyCode);
  document.querySelectorAll('[data-product-price]').forEach(function (price) {
    price.textContent = priceText;
  });
  const compare = wrapper.querySelector('[data-product-compare]');
  const saleBadge = wrapper.querySelector('[data-product-sale-badge]');
  const compareCents = Number(option.dataset.compareCents || 0);
  const priceCents = Number(option.dataset.priceCents || 0);
  const isOnSale = compareCents > priceCents;
  if (compare) {
    compare.hidden = !isOnSale;
    compare.textContent = isOnSale ? formatProductMoney(compareCents, currencyCode) : '';
  }
  if (saleBadge) saleBadge.hidden = !isOnSale;

  const gallery = wrapper.querySelector('[data-product-gallery]');
  const slides = gallery ? Array.from(gallery.querySelectorAll('[data-product-media-slide]')) : [];
  const targetIndex = resolveVariantMediaIndex(wrapper, option, slides);
  if (gallery && typeof gallery.showProductMedia === 'function') gallery.showProductMedia(targetIndex);

  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set('variant', option.value);
  window.history.replaceState({}, '', nextUrl.toString());
});

function initHomeCarousels(root) {
  (root || document).querySelectorAll('[data-carousel]').forEach(function (carousel) {
    if (carousel.dataset.carouselReady === 'true') return;
    carousel.dataset.carouselReady = 'true';
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (slides.length < 2) return;

    let index = 0;
    let timer;
    const delay = Math.max(3000, Number(carousel.dataset.autoplay || 5000));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function showSlide(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, dotIndex) {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function stop() { window.clearInterval(timer); }
    function start() {
      stop();
      if (reduceMotion || document.hidden) return;
      timer = window.setInterval(function () { showSlide(index + 1); }, delay);
    }
    function move(nextIndex) { showSlide(nextIndex); start(); }

    if (previous) previous.addEventListener('click', function () { move(index - 1); });
    if (next) next.addEventListener('click', function () { move(index + 1); });
    dots.forEach(function (dot) { dot.addEventListener('click', function () { move(Number(dot.dataset.carouselDot)); }); });
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    showSlide(0);
    start();
  });
}

function initAPlusCarousels(root) {
  (root || document).querySelectorAll('[data-aplus-carousel]').forEach(function (carousel) {
    if (carousel.dataset.aplusReady === 'true') return;
    carousel.dataset.aplusReady = 'true';
    const viewport = carousel.querySelector('[data-aplus-viewport]');
    const slides = Array.from(carousel.querySelectorAll('[data-aplus-slide]'));
    const tabs = Array.from(carousel.querySelectorAll('[data-aplus-dot]'));
    const tabsHost = carousel.querySelector('.aplus-carousel__tabs');
    const previous = carousel.querySelector('[data-aplus-prev]');
    const next = carousel.querySelector('[data-aplus-next]');
    const dotsHost = carousel.querySelector('[data-aplus-mobile-dots]');
    if (!viewport || !slides.length) return;

    let index = 0;
    let timer;
    let frame;
    const delay = Math.max(4000, Number(carousel.dataset.autoplay || 6500));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobileDots = slides.map(function (_, dotIndex) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show feature ' + (dotIndex + 1));
      dot.addEventListener('click', function () { goTo(dotIndex); restart(); });
      if (dotsHost) dotsHost.appendChild(dot);
      return dot;
    });

    function setActive(nextIndex) {
      index = Math.max(0, Math.min(nextIndex, slides.length - 1));
      tabs.forEach(function (tab, tabIndex) {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      // Keep the active tab visible without scrolling the whole document.
      // Element.scrollIntoView() can move the page vertically when this
      // carousel autoplays while a customer is watching a UGC video below.
      const activeTab = tabs[index];
      if (activeTab && tabsHost) {
        const targetLeft = activeTab.offsetLeft - ((tabsHost.clientWidth - activeTab.offsetWidth) / 2);
        tabsHost.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
      mobileDots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); });
    }
    function goTo(nextIndex, behavior) {
      const safeIndex = (nextIndex + slides.length) % slides.length;
      viewport.scrollTo({ left: safeIndex * viewport.clientWidth, behavior: behavior || 'smooth' });
      setActive(safeIndex);
    }
    function stop() { window.clearInterval(timer); }
    function restart() {
      stop();
      if (reduceMotion || document.hidden) return;
      timer = window.setInterval(function () { goTo(index + 1); }, delay);
    }

    if (previous) previous.addEventListener('click', function () { goTo(index - 1); restart(); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); restart(); });
    tabs.forEach(function (tab) { tab.addEventListener('click', function () { goTo(Number(tab.dataset.aplusDot)); restart(); }); });
    viewport.addEventListener('scroll', function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () { setActive(Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1))); });
    }, { passive: true });
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', restart);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', restart);
    setActive(0);
    restart();
  });
}

initHomeCarousels(document);
initAPlusCarousels(document);
document.addEventListener('shopify:section:load', function (event) {
  initHomeCarousels(event.target);
  initAPlusCarousels(event.target);
});

document.querySelectorAll('[data-newsletter-popup]').forEach(function (popup) {
  const key = 'hikenture-newsletter-popup-seen-v4';
  const delay = Number(popup.dataset.delay || 750);
  const forceOpen = new URLSearchParams(window.location.search).get('newsletter') === '1';
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  let hasSeen = document.cookie.split('; ').some(function (cookie) { return cookie.indexOf(key + '=') === 0; });
  try { hasSeen = hasSeen || window.localStorage.getItem(key) === '1'; } catch (error) {}

  function rememberPopup() {
    try { window.localStorage.setItem(key, '1'); } catch (error) {}
    document.cookie = key + '=1; path=/; max-age=31536000; SameSite=Lax';
  }

  function openPopup() {
    rememberPopup();
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  popup.querySelectorAll('[data-newsletter-close]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      closePopup();
    });
  });
  document.querySelectorAll('[data-newsletter-open]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      openPopup();
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });
  const form = popup.querySelector('form');
  if (form) form.addEventListener('submit', rememberPopup);
  if (forceOpen || designMode || !hasSeen) window.setTimeout(openPopup, delay);
});

document.querySelectorAll('[data-catalog]').forEach(function (catalog) {
  const params = new URLSearchParams(window.location.search);
  const group = params.get('group') || 'all';
  const cards = Array.from(catalog.querySelectorAll('[data-product-group]'));
  const title = catalog.querySelector('[data-catalog-title]');
  const intro = catalog.querySelector('[data-catalog-intro]');
  const labels = {
    all: ['The Hikenture Collection', 'A focused collection of practical outdoor essentials.'],
    wagons: ['Wagons', 'Two purpose-built wagons for everyday hauling and soft-sand beach days.'],
    sleep: ['Sleep & Camp', 'Packable comfort for campsites, road trips and nights in your vehicle.'],
    winter: ['Winter Gear', 'Warm, practical protection for cold-weather days outside.']
  };
  const active = labels[group] ? group : 'all';
  cards.forEach(function (card) {
    card.hidden = active !== 'all' && card.dataset.productGroup !== active;
  });
  catalog.querySelectorAll('[data-catalog-filter]').forEach(function (filter) {
    filter.classList.toggle('is-active', filter.dataset.catalogFilter === active);
  });
  if (title) title.textContent = labels[active][0];
  if (intro) intro.textContent = labels[active][1];
});

(function initCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const itemsHost = drawer.querySelector('[data-cart-items]');
  const footer = drawer.querySelector('[data-cart-footer]');
  const total = drawer.querySelector('[data-cart-total]');
  const status = drawer.querySelector('[data-cart-status]');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function escapeHtml(value) {
    const node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (count) {
      count.textContent = cart.item_count;
    });

    if (!cart.items.length) {
      itemsHost.innerHTML = '<div class="cart-drawer__empty"><h3>Your cart is empty.</h3><p>Explore practical gear for carrying, sleeping and cold-weather comfort.</p></div>';
      footer.hidden = true;
      return;
    }

    itemsHost.innerHTML = cart.items.map(function (item) {
      const options = (item.options_with_values || []).filter(function (option) {
        return option.value && option.value !== 'Default Title';
      }).map(function (option) {
        return '<small>' + escapeHtml(option.name) + ': ' + escapeHtml(option.value) + '</small>';
      }).join('');
      const imageUrl = item.image ? item.image + (item.image.indexOf('?') >= 0 ? '&' : '?') + 'width=220' : '';
      const image = imageUrl ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + '">' : '';
      return '<article class="cart-drawer__item">' + image + '<div><strong>' + escapeHtml(item.product_title) + '</strong>' + options + '<span>' + item.quantity + ' &times; ' + formatProductMoney(item.final_price, cart.currency) + '</span></div></article>';
    }).join('');
    total.textContent = formatProductMoney(cart.total_price, cart.currency);
    footer.hidden = false;
  }

  async function refreshCart() {
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load the cart.');
    const cart = await response.json();
    renderCart(cart);
  }

  document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-cart-open]');
    if (openButton) {
      event.preventDefault();
      refreshCart().then(openDrawer).catch(function () { window.location.href = openButton.href; });
      return;
    }
    if (event.target.closest('[data-cart-close]')) closeDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('form.product-form');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
    status.textContent = '';

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
      await refreshCart();
      status.textContent = 'Added to your cart.';
      openDrawer();
    } catch (error) {
      status.textContent = error.message || 'Unable to add this item. Please try again.';
      openDrawer();
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalLabel;
      }
    }
  });
})();
